import { t } from 'i18next';
import React from 'react';
export const prepareDataForTable = (data) =>
  data.map((account) => ({
    id: account.id,
    [t('Settings.name')]: {
      id: 'title',
      sortable: true,
      getValue: () => (
        <div className="badgee">
          <span className="text_col">{account.title}</span>
          {!account?.is_active && (
            <span className="status status--overdue">{t('common.inactive')}</span>
          )}
        </div>
      ),
      width: 1000,
    },
    [t('Settings.category')]: {
      id: 'account_category_name',
      sortable: true,
      getValue: () => (
        <span className="text_col">{account?.account_category.name}</span>
      ),
    },

    [t('Settings.type')]: {
      id: 'account_type_name',
      sortable: true,
      getValue: () => (
        <span className="text_col">{account.account_type.name}</span>
      ),
    },
    [t('Settings.sub_type')]: {
      id: 'account_subtype_name',
      sortable: true,
      getValue: () => (
        <span className="text_col">{account.account_sub_type.name}</span>
      ),
    },
    // [t('Settings.parent_account')]: {
    //   id: 'parent_account_name',
    //   alignRight: true,
    //   sortable: true,
    //   getValue: () =>
    //     account.parent_account_name && (
    //       <span className="text_col">{account.parent_account_name}</span>
    //     ),
    // },
    // [t('Settings.currency')]: {
    //   id: 'currency',
    //   alignRight: true,
    //   sortable: true,
    //   getValue: () => account?.account_currency?.symbol,
    // },
    // [t('Settings.bank_account_number')]: {
    //   id: 'bank_account_no',
    //   alignRight: true,
    //   sortable: true,
    //   getValue: () => (
    //     <span className="text_col">{account?.bank_account_no}</span>
    //   ),
    // },
    // [t('Settings.default_tax')]: {
    //   id: 'tax_name',
    //   alignRight: true,
    //   sortable: true,
    //   getValue: () => account?.account_tax && account?.account_tax?.name,
    // },
    // [t('Settings.number')]: {
    //   id: 'account_no',
    //   alignRight: true,
    //   sortable: true,

    //   getValue: () =>
    //     account.account_no && (
    //       <span className="text_col">{account?.account_no}</span>
    //     ),
    // },
    [t('Settings.balance')]: {
      id: 'account_current_balance',
      alignRight: true,
      sortable: true,
      getValue: () =>
        `${account?.account_currency?.symbol}${account?.account_current_balance}`,
    },
  }));
